<template>
  <div>
    <b-modal
      v-model="showModal"
      centered
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <p class="h3 text-capitalize filterTittle">
        {{ $t("action_plan.assignUsers") }} - {{ actionPlan.name }}
      </p>
      <hr>
      <label class="d-block" for="users">
        {{ $t("alarm_views.fields.users.label") }}
      </label>
      <v-select
          label="user"
          v-model="selectedUsers"
          :options="users"
          class="w-100 mb-2"
          input-id="users"
          multiple
          :reduce="(val) => val.id"
          :disabled="loading"
        />
      <label class="d-block mt-2" for="deadline">
        {{ $t("action_plan.deadline") }} <span class="text-danger">*</span>
      </label>
      <flat-pickr
        id="deadline"
        class="form-control"
        :config="{
          enableTime: true,
          dateFormat: 'Y-m-d H:i:s',
          time_24hr: true,
          minDate: 'today'
        }"
        v-model="deadline"
        :disabled="loading"
      />
      <template #modal-footer="{ close }">
        <b-button
          variant="primary"
          size="sm"
          :disabled="disabledSaveButton"
          @click="setUsers()"
        >
          {{ $t("actions.save") }}
        </b-button>
        <b-button
          size="sm"
          :disabled="loading"
          @click="$emit('close')"
        >
          {{ $t("close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import store from "@/store";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import {useToast} from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { EventBus } from "@/libs/event-bus";

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    actionPlan: {
      type: Object,
      require: true
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const loading = ref(false);

    const selectedUsers = ref([]);

    const users = ref([]);

    const deadline = ref(null);

    //COMPUTED
    const disabledSaveButton = computed(() => !selectedUsers.value.length || !deadline.value || loading.value);

    //METHODS
    const getUsers = async (params) => {
      loading.value = true;

      await store.dispatch('action_plan/getUsers', params)
        .then(response => {
          const { data } = response;

          if (data.length) {
            users.value = data.filter(tenant => tenant.user).map(userTenant => ({
              id: userTenant.user.id,
              user: userTenant.user.email
            }));
          }
        })
        .catch(() => {
          users.value = [];
        })
        .finally(() => {
          loading.value = false;
        })
    }

    const setSelectedUsers = (users) => {
      selectedUsers.value = users;

      if (users.length) {
        const idsUsers = users.map(user => user.id);

        selectedUsers.value = idsUsers;
      }
    }

    const resetDeadline = () => {
      deadline.value = null;
    }

    const setUsers = async () => {
      const params = {
        id_action_plan: props.actionPlan.id,
        users: selectedUsers.value,
        deadline: deadline.value
      }

      loading.value = true;

      await store.dispatch('action_plan/setUsers', params)
        .then(response => {
          const { message } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          EventBus.emit('update-log');
          emit('refresh');
          emit('close');
          deadline.value = null;
        })
        .catch(() => {
          users.value = [];
        })
        .finally(() => {
          loading.value = false;
        })
    }

    return {
      loading,
      selectedUsers,
      users,
      deadline,

      disabledSaveButton,

      getUsers,
      setSelectedUsers,
      setUsers,
      resetDeadline
    }
  }
}
</script>
